import React, { useState } from "react";
import api, { fmtErr } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export const ChangePasswordDialog = ({ trigger }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ vecchia: "", nuova: "", conferma: "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (f.nuova !== f.conferma) { toast.error("Le due password non coincidono"); return; }
    setBusy(true);
    try { await api.post("/auth/change-password", { vecchia: f.vecchia, nuova: f.nuova }); toast.success("Password aggiornata"); setOpen(false); setF({ vecchia: "", nuova: "", conferma: "" }); }
    catch (e) { toast.error(fmtErr(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (<>
    {trigger ? React.cloneElement(trigger, { onClick: () => setOpen(true) }) : <Button variant="ghost" size="icon" title="Cambia password" onClick={() => setOpen(true)} data-testid="change-password-btn"><KeyRound className="w-5 h-5" /></Button>}
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle>Cambia password</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Password attuale</Label><Input type="password" value={f.vecchia} onChange={(e) => setF({ ...f, vecchia: e.target.value })} data-testid="cp-old" /></div>
          <div><Label>Nuova password (min. 8, lettere e numeri)</Label><Input type="password" value={f.nuova} onChange={(e) => setF({ ...f, nuova: e.target.value })} data-testid="cp-new" /></div>
          <div><Label>Conferma nuova password</Label><Input type="password" value={f.conferma} onChange={(e) => setF({ ...f, conferma: e.target.value })} data-testid="cp-confirm" /></div>
        </div>
        <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button><Button onClick={save} disabled={busy || !f.vecchia || !f.nuova} data-testid="cp-save">Salva</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  </>);
};
